import axios from "axios";
import { getStoredAuthToken } from "./authStorage";

const buildVisitPayload = (eventType) => ({
  pageUrl:
    typeof window !== "undefined" && window.location
      ? window.location.href
      : "",
  referrer:
    typeof document !== "undefined" && document.referrer ? document.referrer : "",
  eventType,
});

export const notifyPageVisit = ({ eventType = "page_load", useStoredToken = false } = {}) => {
  const requestConfig = {};
  const storedToken = useStoredToken ? getStoredAuthToken() : "";
  if (storedToken && !axios.defaults.headers["Authorization"]) {
    requestConfig.headers = {
      Authorization: storedToken,
    };
  }

  return axios
    .post("/visits/notify", buildVisitPayload(eventType), requestConfig)
    .catch(() => {
      // Visit alerts should never interrupt the player experience.
    });
};
